import Router from 'next/router';
import { useReduxState } from 'hooks';
import { ConfirmButton } from 'components/common';

import { CourseInView } from './Courses';

interface Props {
  course: CourseInView;
}

const CoursesUserActionJoin = ({ course }: Props) => {
  const { messages } = useReduxState();

  const handleJoin = async () => {
    Router.push(
      '/courses/[...courseParams]',
      `/courses/${course.slug}/${course.chapters[0].slug}`
    );
    return true;
  };

  return (
    <ConfirmButton
      actionText={messages.commonJoin}
      buttonIsRounded={true}
      buttonSize="small"
      buttonStyle={{
        fontSize: '1.3rem',
        padding: '6px 12px 7px'
      }}
      buttonText={messages.commonJoin}
      confirmText={messages.coursesJoinCourseInfo}
      confirmTitle={messages.coursesJoinCourse}
      disabled={!course.chapters?.length}
      onConfirm={handleJoin}
      stopPropagation={true}
    />
  );
};

export default CoursesUserActionJoin;
